import React from "react";
import { Dropdown, Form, Grid, Input } from "semantic-ui-react";
import { getStateOptions } from "../../Helpers";

const BCAddressForm = ({ ...props }) => {
  const stateOptions = getStateOptions();
  return (
    <React.Fragment>
      <Grid.Column width={16}>
        <Form.Field className="">
          <label>Address: </label>
          <Input 
            placeholder="1234 Main Street" 
            onChange={(e) => props.handleFormChange(e.target.value, "address")}
            type="text"
            fluid 
          />
        </Form.Field>
      </Grid.Column>
      <Grid.Column width={16}>
        <Form.Field className="">
          <label>City: </label>
          <Input 
            placeholder="Seattle" 
            onChange={(e) => props.handleFormChange(e.target.value, "city")}
            type="text"
            fluid 
          />
        </Form.Field>
      </Grid.Column>
      <Grid.Column width={8}>
        <Form.Field className="">
          <label>State: </label>
          <Dropdown
            placeholder='State'
            defaultValue="WA"
            fluid
            search
            selection
            options={stateOptions}
            onChange={(e, { value }) => props.handleFormChange(value, "state")}
          />
        </Form.Field>
      </Grid.Column>
      <Grid.Column width={8}>
        <Form.Field className="">
          <label>Zip: </label>
          <Input 
            placeholder="98103" 
            onChange={(e) => props.handleFormChange(e.target.value, "zip")}
            type="number"
            fluid 
          />
        </Form.Field>
      </Grid.Column>
    </React.Fragment>
  );
};

export default BCAddressForm;